import React, { useState } from 'react';
import Cookies from 'universal-cookie';
import CustomModal from '../../components/CustomModal';
import store from '../../store';
import Footer from '../Footer';
import Header from '../Header';
import Sidebar from '../Sidebar';
import { expireTime, isAuthenticated, isClientAuthenticated } from '../../utils';
import { useSelector } from 'react-redux';
import { clientNav } from '../../routes/data/menulist';

const cookies = new Cookies();

const CustomLayout = ({ children, handleNavigate }) => {
  const [togglePwd, setTogglePwd] = useState(false);
  const UserRoleType = useSelector(state => state.authModel.userRole);

  const modal = useSelector((state) => state.notiModel);
  const user = useSelector((state) => state.authModel);
  const { visible, Component, className } = modal;
  const { dispatch } = store;

  const logOut = () => {
    cookies.remove('c-auth-token', { path: '/', expires: expireTime(), secure: true, sameSite: 'strict' });
    localStorage.clear();
    handleNavigate('/', { replace: true });
  };

  const changePasswordPop = () => {
    setTogglePwd(true);
  };

  const handlePwdPop = () => {
    setTogglePwd(!togglePwd);
  }
  let UserData = null
  switch (UserRoleType) {
    case "Admin":
      UserData = user?.admin
      break;
    case "Manager":
      UserData = user?.manager
      break;
    case "Client":
      UserData = user?.client
      break;

    default:
      break;
  }
  return (
    <>
      <div>
        <Header
          handleNavigate={handleNavigate}
          logOut={logOut}
          changePasswordPop={changePasswordPop}
          togglePwd={togglePwd}
          user={UserData}
          setTogglePwd={setTogglePwd}
          handlePwdPop={handlePwdPop}
        />
        <div>
          <div>
            {children}
          </div>
        </div>

        <Footer />
      </div>
      <CustomModal
        className={className}
        visible={visible}
        onCancel={() => dispatch.notiModel.setModalData()}
      >
        {Component}
      </CustomModal>
    </>
  );
};

export default CustomLayout;
